export class Cookie {
  constructor(name, value = null) {
    this.name = name;
    this.value = value;
  }

  static clientCookie(computerId, referrerId) {
    let name = `client-computerid-${referrerId}`;
    let value = `${computerId}`;

    return new Cookie(name, value);
  }

  static cyriCookie(computerId) {
    let name = `cyri-id`;
    let value = `${computerId}`;

    return new Cookie(name, value);
  }

  static systemIdCookie() {
    let name = `cyri-system`;
    //    let value = `${computerID}`;

    return new Cookie(name, "");
  }

  clear = () => {
    var date = new Date();
    date.setTime(date.getTime() - 1);
    document.cookie = `${this.name}= ;expires=${date.toGMTString()}; path=/`;
  };

  set = () => {
    var date = new Date();
    date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000 * 2); // Two years. The recent cap is set at 13 months.

    document.cookie = `${this.name}=${this.value}; expires=${date.toGMTString()}; path=/`;
    //  document.cookie = `${this.name}=${this.value}; path=/`;
    //document.cookie = `${this.name}=${this.value}`;
  };

  get = () => {
    var re = new RegExp("[; ]" + this.name + "=([^\\s;]*)");
    var sMatch = (" " + document.cookie).match(re);
    if (this.name && sMatch) return unescape(sMatch[1]);
    return null;
  };
}
